import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioInnerFn = /* @__PURE__ */ createRecipe('radio-inner', {}, [])

const radioInnerVariantMap = {}

const radioInnerVariantKeys = Object.keys(radioInnerVariantMap)

export const radioInner = /* @__PURE__ */ Object.assign(memo(radioInnerFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioInner',
  __getCompoundVariantCss__: radioInnerFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioInnerVariantKeys,
  variantMap: radioInnerVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioInnerVariantKeys)
  },
  getVariantProps: radioInnerFn.getVariantProps,
})